import Model from './Model'

export default class EquipmentSize extends Model {
  resource()
  {
    return 'equipment-sizes'
  }

  toFilterOptions(models) {
    if (!Array.isArray(models)) return [];
    return models.map(model => ({
      value: String(model.size),
      label: model.size,
    }));
  }
}